import styled from 'styled-components';

import CommonButton from '~/src/common/components/Button';
import CommonInput from '~/src/common/components/Form/Input';
import { media } from '~/src/styles-constants';

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 16px;
  margin-left: -16px;
  margin-right: -16px;
  padding: 16px;
  background-color: ${({ theme }) => theme.palette.common.XLIGHT_GREEN};

  ${media.XL`
    margin-top: 32px;
    margin-left: 0;
    margin-right: 0;
    border-radius: 8px;
  `}
`;

export const FormText = styled.p`
  margin: 0 0 16px;
  text-align: center;

  & > span {
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.common.TEXTS};

    ${media.XL`
    font-size: 16px;
    `}
  }
`;

export const ProposalForm = styled.form`
  & > div {
    display: flex;
  }
`;

const INPUT_HEIGHT = 40;

export const Input = styled(CommonInput)`
  height: ${INPUT_HEIGHT}px;

  background: ${({ theme }) => theme.palette.background};
  border-radius: 4px 0 0 4px;
  border: 1px solid ${({ theme }) => theme.palette.common.BACKGROUND_3};

  &,
  &::placeholder {
    font-size: 14px;
  }
`;

export const SubmitButton = styled(CommonButton)`
  height: ${INPUT_HEIGHT}px;
  width: ${INPUT_HEIGHT}px;
  min-width: ${INPUT_HEIGHT}px;
  background-color: ${({ theme }) => theme.palette.common.PRIMARY};
  color: ${({ theme }) => theme.palette.common.WHITE};
  border-radius: 0 4px 4px 0;

  span {
    max-width: 30px;
  }
`;

export const Button = styled(CommonButton)`
  margin: 0 auto;
`;
